var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44217 0.307462L7.69217 6.55746C7.75028 6.61551 7.79638 6.68444 7.82783 6.76031C7.85928 6.83619 7.87547 6.91752 7.87547 6.99965C7.87547 7.08179 7.85928 7.16311 7.82783 7.23899C7.79638 7.31486 7.75028 7.38379 7.69217 7.44184L1.44217 13.6918C1.32489 13.8091 1.16583 13.875 0.999981 13.875C0.834129 13.875 0.675069 13.8091 0.557793 13.6918C0.440518 13.5746 0.374634 13.4155 0.374634 13.2497C0.374634 13.0838 0.440518 12.9247 0.557793 12.8075L6.36639 6.99965L0.557793 1.19184C0.499724 1.13377 0.453661 1.06483 0.422235 0.988959C0.390808 0.913089 0.374633 0.831771 0.374633 0.749649C0.374633 0.667527 0.390808 0.586209 0.422235 0.510339C0.453661 0.434468 0.499724 0.36553 0.557793 0.307462C0.615862 0.249392 0.6848 0.203331 0.76067 0.171904C0.836541 0.140477 0.917859 0.124301 0.999981 0.124301C1.0821 0.124301 1.16342 0.140477 1.23929 0.171904C1.31516 0.203331 1.3841 0.249392 1.44217 0.307462Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow Right.cfd3d0a4ccbf07694714b582f68f2545.svg";
export { ForwardRef as ReactComponent };